import { MouseEvent } from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

export default function Checkbox({ checked, indeterminate, onClick }: CheckboxProps) {
  return (
    <div
      onClick={onClick}
      className={`${styles.checkbox} ${checked ? styles.checked : ''} ${indeterminate ? styles.indeterminate : ''}`}
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      tabIndex={0}
    >
      {checked && <span className={styles.checkmark}>✓</span>}
      {indeterminate && !checked && <span className={styles.indeterminateMark}>−</span>}
    </div>
  );
}
